<!--
 * @Desc: 教育教学
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-13 08:20:04
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="education-teach">
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/education-teach-title.png"
                    />
                </div>
                <div class="title-more">
                    了解更多
                    <img
                        class="thu"
                        src="../../../public/statics/images/arr.png"
                    />
                </div>
            </div>
            <section class="edu-hold">
                <div class="edu-thu">
                    <img
                        class="thu"
                        src="../../../public/statics/images/Index/icon-pic.jpg"
                    />
                </div>
                <div class="edu-list">
                    <div class="edu-item" v-for="i in 8">
                        <div class="edu-title ellipsis1">
                            聚焦核心素养
                            深化教学改革——恒源中学举行英语学科优质课比…
                        </div>
                        <div class="edu-time">2023-04-29</div>
                    </div>
                    <div class="divider"></div>
                    <div class="more">
                        <p class="text">了解更多</p>
                        <img
                            class="thu"
                            src="../../../public/statics/images/arr-red.png"
                        />
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    created: function () {},
    methods: {},
};
</script>

<style scoped>
.education-teach {
    width: 100%;
    height: 761px;
    background: url(../../../public/statics/images/Index/education-teach-bg.jpg)
        center;
}
.education-teach .container {
    padding-top: 130px;
}
.education-teach .title-hold .title::after {
    width: 193px;
    height: 28px;
    background: url(../../../public/statics/images/Index/education-teach-desc.png);
}
.education-teach .edu-hold {
    display: flex;
    margin-top: 35px;
}
.education-teach .edu-hold .edu-thu {
    width: 622px;
    height: 456px;
}
.education-teach .edu-hold .edu-thu .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.education-teach .edu-hold .edu-list {
    flex: 1;
    background: #fff;
    padding-top: 20px;
}
.education-teach .edu-hold .edu-list .edu-item {
    display: flex;
    justify-content: space-between;
    padding-left: 24px;
    padding-right: 37px;
    line-height: 46px;
    cursor: pointer;
    position: relative;
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
.education-teach .edu-hold .edu-list .edu-item::after {
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    content: "";
    position: absolute;
    top: 1px;
    left: 0;
    width: 4px;
    height: 44px;
    transform: scaleY(0);
    background: rgba(226, 47, 36, 1);
}
.education-teach .edu-hold .edu-list .edu-item .edu-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    flex: 1;
}
.education-teach .edu-hold .edu-list .edu-item .edu-time {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-left: 15px;
}
.education-teach .edu-hold .edu-list .divider {
    width: 518px;
    height: 2px;
    background: #e22f24;
    margin-left: 24px;
    margin-top: 15px;
}
.education-teach .edu-hold .edu-list .more{
    width: 518px;
    height: 24px;
    margin-left: 24px;
    margin-top: 13px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.education-teach .edu-hold .edu-list .more .text{
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 27px;
    color: rgba(226, 47, 36, 1);
    text-align: left;
    vertical-align: middle;
}
.education-teach .edu-hold .edu-list .more .thu{
    width: 19px;
    height: 14px;
}
/* 滑入 */
.education-teach .edu-hold .edu-list .edu-item:hover {
    background: #fbf4eb;
}
.education-teach .edu-hold .edu-list .edu-item:hover::after {
    transform: scaleY(1);
}
.education-teach .edu-hold .edu-list .edu-item:hover .edu-title {
    color: #e22f24;
}
.education-teach .edu-hold .edu-list .edu-item:hover .edu-time {
    color: #e22f24;
}
</style>
